import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../layout/SectionTitle';

const Engagement = () => {
  const { t } = useTranslation();
  return (
    <section className="py-8 bg-white">
      {/* Section Notre Engagement */}
      <div className="bg-socabeg-blue text-white">
        {/* Titre */}
        <div className="container mx-auto px-4 py-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <SectionTitle 
              overline={t('about.engagement.title')}
              highlight=""
              separatorColor="socabeg-red"
              showLogo={true}
              textColor="text-white"
            />
          </motion.div>
        </div>

        {/* Contenu principal avec image à côté du texte */}
        <div className="container mx-auto px-4 pb-8">
          <div className="flex flex-col lg:flex-row items-stretch gap-8 md:gap-12">
            {/* Image - En dessous du titre en mobile, à gauche en desktop */}
            <motion.div 
              className="w-full lg:w-2/5 relative order-1 lg:order-1 h-auto flex justify-center"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="relative w-full pb-[125%] rounded-lg overflow-hidden shadow-xl">
                <img 
                  src="/images/director.png" 
                  alt="Directeur Général" 
                  className="absolute inset-0 w-full h-full object-cover"
                  style={{ objectPosition: 'center' }}
                />
              </div>
            </motion.div>
            
            {/* Texte - À droite de l'image en desktop */}
            <motion.div 
              className="lg:w-3/5 order-2 lg:order-2 mt-5 lg:mt-0"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <blockquote className="text-lg md:text-xl font-semibold mb-6">
                " {t('about.engagement.quote')} "
              </blockquote>
              
              {/* Texte sur une seule colonne */}
              <div className="grid grid-cols-1 gap-6 text-white/90">
                <div>
                  <p className="mb-4 text-justify">
                    {t('about.engagement.paragraph1')}
                  </p>
                  
                  <p className="text-justify">
                    {t('about.engagement.paragraph2')}
                  </p>
                </div>
                
                <div>
                  <p className="mb-4 text-justify">
                    {t('about.engagement.paragraph3')}
                  </p>
                  
                  <p className="mb-4 text-justify">
                    {t('about.engagement.paragraph4')}
                  </p>
                  
                  <p className="text-justify">
                    {t('about.engagement.paragraph5')}
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Engagement;
